import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f5270c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Action", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Publish selecteds ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "cursor-pointer hover:underline primary ..." }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Out of stock ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(` Created by URL`))
const _hoisted_13 = {
  key: 0,
  class: "pb-6"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold pb-2" }, "COLORS", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "flex items-center justify-start"
}
const _hoisted_18 = { class: "pb-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold pb-2" }, "SIZES", -1))
const _hoisted_20 = {
  key: 0,
  class: "flex items-center justify-start"
}
const _hoisted_21 = { class: "uppercase" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-base font-bold" }
const _hoisted_25 = {
  class: "flex items-baseline",
  style: {"flex-direction":"column"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.state.multipleSelection.length !== 0)
        ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPublishSelected()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.multipleSelection.length) + " selecteds ", 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _hoisted_2,
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_5
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.documents,
      "element-loading-text": "Loading...",
      lazy: "",
      onSelectionChange: _ctx.handleSelectionChange,
      style: {"width":"100%"},
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          "min-width": 5
        }),
        _createVNode(_component_el_table_column, { "min-width": 80 }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  md: 5,
                  class: "flex items-center",
                  style: {"min-width":"230px"}
                }, {
                  default: _withCtx(() => [
                    (
                scope.row.mockupGallery && scope.row.mockupGallery.length > 0
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_el_image, {
                            class: "image-200",
                            src: _ctx.imageUrl(scope.row.mockupGallery[0], true, 300),
                            "preview-src-list": [_ctx.imageUrl(scope.row.mockupGallery[0])],
                            fit: "cover"
                          }, {
                            error: _withCtx(() => [
                              _createVNode(_component_slot_error)
                            ]),
                            _: 2
                          }, 1032, ["src", "preview-src-list"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_el_image, { class: "image-200" }, {
                            error: _withCtx(() => [
                              _createVNode(_component_slot_error)
                            ]),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_col, { md: 15 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "text-base text-primary font-bold pb-6",
                      onClick: ($event: any) => (_ctx.edit(scope.row))
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(scope.row.name), 1),
                      (scope.row.dropship === true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              class: "ml-3",
                              type: _ctx.getPublishStatusTagColor(scope.row.publishStatus)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getPublishStatusName(scope.row.publishStatus)), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"]),
                            (scope.row.outOfStock === true)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  size: "small",
                                  type: "error",
                                  class: "ml-3"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (scope.row.productStore)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  size: "small",
                                  class: "ml-3"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_8),
                    (scope.row.colors && scope.row.colors.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          (scope.row.dropship === true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.colors, (color, indexColor) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: `color${indexColor}`
                                  }, [
                                    _createTextVNode(_toDisplayString(color.name) + " ", 1),
                                    (indexColor < scope.row.colors.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ,  "))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.colors, (color, indexColor) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "catalog-attribute mr-1",
                                    style: _normalizeStyle(`--background: ${color.name};`),
                                    key: `color${indexColor}`
                                  }, null, 4))
                                }), 128))
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      (scope.row.sizes.length < 10)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.sizes, (size, indexSize) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "",
                                key: `size${indexSize}`
                              }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(size.name) + " ", 1),
                                  (indexSize < scope.row.sizes.length - 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ,  "))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(scope.row.sizes.length) + " sizes", 1)
                          ]))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { "min-width": 15 }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_24, _toDisplayString(scope.row.productCode), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { "min-width": 10 }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.edit(scope.row)),
                size: "small",
                class: "my-1",
                title: "Edit catalog"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Edit)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.clone(scope.row?._id)),
                size: "small",
                class: "my-1",
                title: "Clone catalog"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DocumentCopy)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => (_ctx.delCatalog(scope.row._id)),
                title: "Can not delete catalog. Please contact admin.",
                class: "my-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Delete)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"])
  ], 64))
}